const images = [
    { id: 1, image: '/phone-front.png', label: 'Front', note: 'Upload image' },
    { id: 2, image: '/phone-back.png', label: 'Back', note: 'Upload image' },
    { id: 3, image: '/imei.png', label: 'IMEI', note: '12345678901245' },
    { id: 4, image: '/label.png', label: 'Label', note: 'Upload image' }
  ];

  export default images;